import { Box } from "@mui/material";
import React from "react";

const OneCardSpread = ({
    size,
    displaySpread,
    getCard
}: {
    size: number,
    displaySpread: boolean,
    getCard: (index: number) => React.ReactNode
}) => {
    return (
        <Box sx={{
            display: displaySpread ? 'flex' : 'none',
            justifyContent: 'center',
            alignItems: 'center',
            padding: "5px",
            width: '100%',
            height: '100%',
            margin: '0 auto',
            overflow: 'hidden'
        }}>
            {getCard(0)}
        </Box>
    );
};

export default OneCardSpread;

